import { render, staticRenderFns } from "./VueSimpleSuggest.vue?vue&type=template&id=c340e08a&"
import script from "./VueSimpleSuggest.vue?vue&type=script&lang=js&"
export * from "./VueSimpleSuggest.vue?vue&type=script&lang=js&"
import style0 from "./VueSimpleSuggest.vue?vue&type=style&index=0&id=c340e08a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports